<div class="modal-header wizard-header">
  <div class="wizard-header-top">
    <div class="wizard-header-titles">
      <span class="wizard-step-counter text-muted" data-cy="wizard-step-counter">
        {{ 'TICKETS.VERIFICATION_WIZARD.STEP_COUNTER' | translate: { current: currentStepIndex + 1, total: steps.length } }}
      </span>
      <h4 class="modal-title">{{ title | translate }}</h4>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancelClicked.emit()"></button>
  </div>
  <ol class="wizard-stepper" data-cy="wizard-stepper">
    @for (step of steps; track step.id; let i = $index) {
      <li class="wizard-stepper-item" [class.connector-completed]="i > 0 && isStepCompleted(i - 1)">
        <button
          type="button"
          class="wizard-stepper-node"
          [class.active]="i === currentStepIndex"
          [class.completed]="isStepCompleted(i)"
          [disabled]="!isStepAccessible(i)"
          [attr.aria-current]="i === currentStepIndex ? 'step' : null"
          [attr.data-cy]="'wizard-stepper-node-' + step.id"
          (click)="selectStep(i)">
          @if (isStepCompleted(i)) {
            <fa-icon [icon]="faCheck"></fa-icon>
          } @else {
            {{ i + 1 }}
          }
        </button>
        <span class="wizard-stepper-label" [class.active]="i === currentStepIndex">{{ step.titleKey | translate }}</span>
      </li>
    }
  </ol>
</div>
<div class="modal-body">
  <ng-content></ng-content>
</div>
<div class="modal-footer">
  @if (isFirstStep) {
    <button type="button" class="btn btn-secondary" data-cy="wizard-cancel-button" (click)="cancelClicked.emit()">
      {{ 'TICKETS.VERIFICATION_WIZARD.BUTTONS.CANCEL' | translate }}
    </button>
  } @else {
    <button type="button" class="btn btn-secondary" data-cy="wizard-back-button" (click)="backClicked.emit()">
      {{ 'TICKETS.VERIFICATION_WIZARD.BUTTONS.BACK' | translate }}
    </button>
  }
  <button type="button" class="btn btn-primary" data-cy="wizard-next-button" [disabled]="nextDisabled" (click)="nextClicked.emit()">
    {{ (isLastStep ? 'TICKETS.VERIFICATION_WIZARD.BUTTONS.SUBMIT' : 'TICKETS.VERIFICATION_WIZARD.BUTTONS.NEXT') | translate }}
  </button>
</div>
